import { render, staticRenderFns } from "./PlatformHelp.vue?vue&type=template&id=6f96e080&scoped=true&"
import script from "./PlatformHelp.vue?vue&type=script&lang=js&"
export * from "./PlatformHelp.vue?vue&type=script&lang=js&"
import style0 from "./PlatformHelp.vue?vue&type=style&index=0&id=6f96e080&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f96e080",
  null
  
)

export default component.exports